import { render, staticRenderFns } from "./Viewticket.vue?vue&type=template&id=1ed362d0"
import script from "./Viewticket.vue?vue&type=script&lang=js"
export * from "./Viewticket.vue?vue&type=script&lang=js"
import style0 from "./Viewticket.vue?vue&type=style&index=0&id=1ed362d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports